import PermissionRequest from "components/PermissionRequest";
import { Permissions } from "interface/role";
import React, { FunctionComponent, ReactElement } from "react";
import { store } from "store";

export default function addPermissions(Element: FunctionComponent | ReactElement<any, any>, requiredPermissions: Array<Permissions> = [], fn?: () => boolean) {
   
    const userPermissions: Array<string> = store.getState().user.merchant?.user.member.role.permissions ?? [];
    const hasPermissions = () => {
      if(!requiredPermissions.length) {
        return true;
      }
      return requiredPermissions.join(',').includes(userPermissions.join(','))
    }
    if (requiredPermissions && (requiredPermissions.length || fn)) {
      if(!hasPermissions() || (fn && !fn())) {
        // TODO: return no access screen
        return (
          <PermissionRequest permission={requiredPermissions} />
        )
      }
    }
  if((Element as ReactElement<any, any>).type) {
    return Element;
  }
  // @ts-ignore
    return <Element />;
  }